import { VySwitchRow, type VySwitchRowProps } from '@vy/ui-design-system';
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form';
import { useFieldController } from './useFieldController';

export type VySwitchFieldProps<TForm extends FieldValues> = Omit<
  VySwitchRowProps,
  'checked' | 'onChange' | 'error' | 'helperText'
> & {
  name: FieldPath<TForm>;
  helperText?: string;
};

export function VySwitchField<TForm extends FieldValues>({
  name,
  helperText,
  ...rest
}: VySwitchFieldProps<TForm>) {
  const { control, message } = useFieldController<TForm>(name);
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <VySwitchRow
          {...rest}
          checked={Boolean(field.value)}
          onChange={(_event, next) => field.onChange(next)}
          onBlur={field.onBlur}
          error={Boolean(message)}
          helperText={message ?? helperText}
        />
      )}
    />
  );
}
